module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list_nav_wrap toggle-nav"
  }, [_c('h1', {
    staticClass: "list_nav_title"
  }, [_c('label', [_vm._v(_vm._s(_vm.keyName))])]), _vm._v(" "), _c('div', {
    staticClass: "sc-option",
    staticStyle: {
      "z-index": "994"
    },
    attrs: {
      "data-ui": "dropdown",
      "id": "brand_option"
    }
  }, [_c('div', {
    staticClass: "sc-option-hd",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_c('div', {
    staticClass: "sc-option-content"
  }, [_vm._v("\n                " + _vm._s(_vm.activeName) + "\n            ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.show) ? _c('ul', {
    staticClass: "sc-option-list",
    staticStyle: {
      "top": "25px"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "id-data": item.value
      },
      on: {
        "click": function($event) {
          _vm.doSelect(item.value)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])])
  })) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-option-action"
  }, [_c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-281fd3f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/NavContainer/ListNav/NavStandard.vue
// module id = 844
// module chunks = 5